import { Box, Collapse, Flex, Text } from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconCheckedSmall } from "components/icons/Icons";
import CreditCardIcon from "assets/img/customer/credit-card.svg";
import AddNewCardToggle from "./AddNewCardToggle";
import NewCardForm from "./NewCardForm";
import SavedCardsList from "./SavedCardsList";

export default function CardPaymentSection(props: {
  payment: string | null;
  isGettingCards: boolean;
  cards: any[];
  selectedCard: any;
  openCardInputForm: boolean;
  cardHolderName: string;
  setCardHolderName: (next: string) => void;
  cardBrand: string;
  selectStripe: () => void;
  onSelectCard: (card: any) => void;
  onToggleAddNewCard: () => void;
  onRemoveCard: (cardId: number) => void;
}) {
  const {
    payment,
    isGettingCards,
    cards,
    selectedCard,
    openCardInputForm,
    cardHolderName,
    setCardHolderName,
    cardBrand,
    selectStripe,
    onSelectCard,
    onToggleAddNewCard,
    onRemoveCard,
  } = props;

  return (
    <Box p={{ base: "14px", md: "16px" }} borderRadius="12px" border="1px solid #D2DAE5" bg="#FFF">
      <Flex
        alignItems="center"
        gap="16px"
        cursor="pointer"
        onClick={() => {
          selectStripe();
        }}
      >
        <Box
          w="18px"
          h="18px"
          borderRadius="50%"
          border="1px solid #2F80ED"
          bgColor={payment === "paypal" ? "#FFF" : "#2F80ED"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <IconBox w="14px" h="11px" icon={<IconCheckedSmall w="12px" h="10px" />} />
        </Box>
        <Box as="img" src={CreditCardIcon} alt="Credit card" w="20px" h="20px" />
        <Text fontSize="16px" lineHeight="24px" fontWeight="400" color="#000">
          Card
        </Text>
      </Flex>

      <Collapse in={payment !== "paypal"} animateOpacity unmountOnExit>
        <Box mt="14px">
          {isGettingCards ? (
            <Text fontSize="14px" color="#667085">
              Loading saved cards...
            </Text>
          ) : cards?.length > 0 ? (
            <SavedCardsList
              cards={cards}
              selectedCard={selectedCard}
              onSelectCard={onSelectCard}
              onRemoveCard={onRemoveCard}
            />
          ) : (
            <Text fontSize="14px" color="#667085">
              No saved cards yet.
            </Text>
          )}
        </Box>

        {!isGettingCards && (
          <AddNewCardToggle open={openCardInputForm} onToggle={onToggleAddNewCard} isDisabled={false} />
        )}

        <Collapse in={openCardInputForm} animateOpacity unmountOnExit>
          <NewCardForm
            cardBrand={cardBrand}
            cardHolderName={cardHolderName}
            setCardHolderName={setCardHolderName}
            onFocusStripe={selectStripe}
          />
        </Collapse>
      </Collapse>
    </Box>
  );
}
